import * as XLSX from 'xlsx';


export class ExportarExcel {

  exportarExcel(table: any, columns?, data?: any[]){
    let ws: XLSX.WorkSheet;
    const tableExport = table.nativeElement.cloneNode(true) as HTMLElement;
    const elementos = tableExport.querySelectorAll('.ignoreprint');
    elementos.forEach(el => el.remove());

    if (columns !== undefined) {
      // Filtra las columnas que deseas exportar
      const filteredData = [...data].map(item => {
        const filteredItem: any = {};
        columns.forEach(column => {
          filteredItem[column] = item[column];
        });
        return filteredItem;
      });
      ws = XLSX.utils.json_to_sheet(filteredData);
    } else {
      ws = XLSX.utils.table_to_sheet(tableExport);
    }

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'DescargaExcel.xlsx');
  }

  exportarExcelColumnas(data: any[], columnsToExport: string[]) {
    // Filtra las columnas que deseas exportar
    const filteredData = data.map(item => {
      const filteredItem: any = {};
      columnsToExport.forEach(column => {
        filteredItem[column] = item[column];
      });
      return filteredItem;
    });

    // Crea un libro de Excel
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // Guarda el libro de Excel como un archivo
    XLSX.writeFile(wb, `Reporte_General.xlsx`);
  }


}
